import { disableXRay } from '../state/ui-store';
import { changeXrayVisibilityGroup } from './change-xray-visibility-group';

export const hideXrayView = () => {
  disableXRay();
  changeXrayVisibilityGroup();
};
